import { create } from 'zustand';
import { getItemDescriptionMappings } from '../api/receipt';

interface DescriptionMappingState {
  options: string[];
  isLoaded: boolean;
  fetchMappings: () => Promise<void>;
  refresh: () => Promise<void>;
}

export const useDescriptionMappingStore = create<DescriptionMappingState>((set, get) => ({
  options: [],
  isLoaded: false,

  fetchMappings: async () => {
    if (get().isLoaded) return;
    try {
      const response = await getItemDescriptionMappings();
      const descriptions = response.mappings
        .map((mapping) => (mapping.customDescription || mapping.originalDescription).trim())
        .filter((description) => description.length > 0);
      set({
        options: Array.from(new Set(descriptions)).sort((a, b) => a.localeCompare(b)),
        isLoaded: true,
      });
    } catch {
      // Silently fail - description suggestions are not critical
    }
  },

  refresh: async () => {
    set({ isLoaded: false });
    await get().fetchMappings();
  },
}));
